import update from 'react/lib/update';

const INITIALIZE_COLLAPSE = 'hg/collapse/INITIALIZE_COLLAPSE';
const TOGGLE_PANEL = 'hg/collapse/TOGGLE_PANEL';

const initialState = {
  collapse: {}
};

export default function collapse(state = initialState, action = {}) {
  switch (action.type) {
    case INITIALIZE_COLLAPSE:
      return {
        ...state,
        collapse: {
          ...state.collapse,
          [action.collapseName]: action.collapseChildren
        }
      };
    case TOGGLE_PANEL:
      return {
        ...state,
        collapse: update(state.collapse,
          { [action.collapseName]: { [action.collapseIndex]: { $set: action.collapseStatus } } }
        )
      };
    default:
      return state;
  }
}

function toggelPanel(name, index, status) {
  return {
    type: TOGGLE_PANEL,
    collapseName: name,
    collapseIndex: index,
    collapseStatus: status
  };
}

export function dispatchToggelPanel(name, index, status) {
  return toggelPanel(name, index, status);
}

function initializeCollapse(name, children) {
  return {
    type: INITIALIZE_COLLAPSE,
    collapseName: name,
    collapseChildren: children
  };
}

export function dispatchInitializeCollapse(name, children) {
  return initializeCollapse(name, children);
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/collapse/collapse.js
 **/